import React from "react";

import { useIntl } from "react-intl";

import { Button, Popconfirm } from "@mapmycustomers/ui";

interface Props {
  onClick: () => void;
}

const CloneDataToMainAppButton: React.FC<Props> = ({ onClick }) => {
  const intl = useIntl();
  return (
    <Popconfirm
      cancelText={intl.formatMessage({
        id: "settings.sandboxEnvironment.state.cloneDataToMainApp.confirm.cancel",
        defaultMessage: "Wait",
        description: "Settings Sandbox Environment - state - Back to main account - cancel",
      })}
      description={intl.formatMessage({
        id: "settings.sandboxEnvironment.state.cloneDataToMainApp.confirm.text",
        defaultMessage:
          "Are you sure you’re ready to clone back into your production environment? This action cannot be reversed.",
        description: "Settings Sandbox Environment - state - Back to main account - confirmation",
      })}
      okText={intl.formatMessage({
        id: "settings.sandboxEnvironment.state.cloneDataToMainApp.confirm.ok",
        defaultMessage: "Proceed",
        description: "Settings Sandbox Environment - state - Back to main account - proceed",
      })}
      onConfirm={onClick}
      placement="bottom"
    >
      <Button type="primary">
        {intl.formatMessage({
          id: "settings.sandboxEnvironment.state.cloneDataToMainApp",
          defaultMessage: "Clone configuration to production",
          description: "Settings Sandbox Environment - state - Back to main account",
        })}
      </Button>
    </Popconfirm>
  );
};

export default CloneDataToMainAppButton;
